var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.5,
    stroke: "#179CF0",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.75 14.25C36.3467 14.25 36.919 14.4871 37.341 14.909C37.7629 15.331 38 15.9033 38 16.5V43.5C38 44.0967 37.7629 44.669 37.341 45.091C36.919 45.5129 36.3467 45.75 35.75 45.75H22.25C21.6533 45.75 21.081 45.5129 20.659 45.091C20.2371 44.669 20 44.0967 20 43.5V16.5C20 15.9033 20.2371 15.331 20.659 14.909C21.081 14.4871 21.6533 14.25 22.25 14.25H35.75ZM22.25 12C21.0565 12 19.9119 12.4741 19.068 13.318C18.2241 14.1619 17.75 15.3065 17.75 16.5V43.5C17.75 44.6935 18.2241 45.8381 19.068 46.682C19.9119 47.5259 21.0565 48 22.25 48H35.75C36.9435 48 38.0881 47.5259 38.932 46.682C39.7759 45.8381 40.25 44.6935 40.25 43.5V16.5C40.25 15.3065 39.7759 14.1619 38.932 13.318C38.0881 12.4741 36.9435 12 35.75 12H22.25Z",
    fill: "#179CF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 43.5C29.5967 43.5 30.169 43.2629 30.591 42.841C31.0129 42.419 31.25 41.8467 31.25 41.25C31.25 40.6533 31.0129 40.081 30.591 39.659C30.169 39.2371 29.5967 39 29 39C28.4033 39 27.831 39.2371 27.409 39.659C26.9871 40.081 26.75 40.6533 26.75 41.25C26.75 41.8467 26.9871 42.419 27.409 42.841C27.831 43.2629 28.4033 43.5 29 43.5Z",
    fill: "#179CF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon7.21fc8446c5d72c77ddb64d5b80b616d6.svg";
export { ForwardRef as ReactComponent };